///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, inject, OnInit } from '@angular/core';
import { MatDialogClose, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { PlannerEulaDTO } from '../../../generated/shared-types.model';
import { Store } from '@ngrx/store';
import { selectEula } from '../../../shared/store/eula/eula.selectors';
import { LoaderIds, PreloaderService } from '../../../services/preloader.service';
import { UserAuthorities } from '../../../services/user/user-authorities';
import { Actions, ofType } from '@ngrx/effects';
import { closeEulaUpdateDialog, getEula, uploadEula } from '../../../shared/store/eula/eula.actions';
import { AsyncPipe, DatePipe } from '@angular/common';
import { ButtonsDirectivesModule } from '../../../shared/directives/buttons-directives/buttons-directives.module';
import { SuiLoadingDirective, SuiSvgIconComponent, SuiTranslatePipe } from '@siklu/sui-lib';

@Component({
    selector: 'winde-update-eula-dialog',
    templateUrl: './update-eula-dialog.component.html',
    imports: [
        AsyncPipe,
        ButtonsDirectivesModule,
        DatePipe,
        MatDialogClose,
        MatDialogTitle,
        SuiSvgIconComponent,
        SuiTranslatePipe,
        SuiLoadingDirective
    ],
    styleUrls: ['../eula-dialogs.scss']
})
export class UpdateEulaDialogComponent implements OnInit {
    public eula$: Observable<PlannerEulaDTO> = inject(Store).select(selectEula);
    public selectedFile: File = null;
    public readonly downloadUrl: string = `/api/eula/file`;
    public readonly loaderKey: LoaderIds = LoaderIds.UPDATE_EULA_ID;
    public readonly preloaderService = inject(PreloaderService);
    protected readonly userAuthorities = UserAuthorities;
    private readonly store = inject(Store);
    private readonly actions$ = inject(Actions);
    private readonly dialogRef = inject(MatDialogRef<UpdateEulaDialogComponent>);

    constructor() {
        this.actions$.pipe(ofType(closeEulaUpdateDialog)).subscribe(() => this.dialogRef.close());
    }

    public ngOnInit(): void {
        this.store.dispatch(getEula());
    }

    public selectFile(event: Event): void {
        this.selectedFile = (event.target as HTMLInputElement)?.files?.[0];
    }

    public uploadEula(): void {
        this.store.dispatch(uploadEula({ file: this.selectedFile }));
    }
}
